export class UserInfo {
    gender: string;
    fitness: Array<any>;
    date_of_birth: string;
}
